/** Shared Guardians workbench toolbar control sizing (search, filters, settings). */
export const guardiansToolbarIconButtonClass =
  "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-800 text-slate-300 hover:bg-slate-700";

export const guardiansToolbarFiltersButtonClass =
  "inline-flex h-9 min-w-0 max-w-full shrink items-center gap-1.5 overflow-hidden rounded-lg bg-slate-800 px-2.5 text-sm text-slate-200 hover:bg-slate-700";

export {
  GUARDIANS_TOOLBAR_ACTION_MIN_WIDTH_PX,
  GUARDIANS_TOOLBAR_SLOT_MIN_WIDTH_PX,
} from "./compressToolbarLabel";

/** Primary action shown in the optional toolbar slot (full audit, new audit, …). */
export const guardiansToolbarSlotButtonClass =
  "inline-flex h-9 min-w-0 max-w-full shrink items-center gap-1.5 overflow-hidden rounded-lg px-2.5 text-sm font-medium";
